import {BigDecimal} from '@dms/api/shared';

export type PurchaseBankTransferPaymentRequestBody = {
  paymentDiscriminator: PurchaseBankTransferPaymentRequestBody.paymentDiscriminator;
  paymentMethod: PurchaseBankTransferPaymentRequestBody.paymentMethod;
  dueDate: string;
  customerBankAccountId: string;
  amount: BigDecimal;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace PurchaseBankTransferPaymentRequestBody {
  export enum paymentDiscriminator {
    PURCHASE = 'PURCHASE',
  }

  export enum paymentMethod {
    BANK_TRANSFER = 'BANK_TRANSFER',
  }
}
